module.exports = __webpack_public_path__ + "static/media/paiement-facture.42c98125.jpeg";